import { createSelector } from 'reselect';
import { initialState } from './wishlist.reducers';

const selectWishList = (state: any) => state.wishListReducer || initialState;

const makeSelectWishListCatalogue = () =>
  createSelector(
    selectWishList,
    wishListState => wishListState.wishListCatalogue,
  );

const makeSelectWishList = () =>
  createSelector(
    selectWishList,
    wishListState => wishListState.wishList,
  );

const makeSelectWish = () =>
  createSelector(
    selectWishList,
    wishListState => wishListState.wish,
  );

export { makeSelectWishListCatalogue, makeSelectWishList, makeSelectWish };
